import './style.scss';
import { UnderlineDateInput, DateInputProps } from 'views/mutual/dateInput';
import { TimeSelector, SelectorProps } from 'views/templates/module/selector';

type DateTimePreferenceProps = {
    title: string;
    dateInputProps : DateInputProps;
    selectorProps : SelectorProps;
}

//TODO: 細かいプロパティは確認する
export const DateTimePreference = (props : DateTimePreferenceProps) => {
    const { title } = props;
    return (
        <div className='dateTimePreference'>
            <div className='dateTimePreference_title'>
                {title}
            </div>
            <UnderlineDateInput {...props.dateInputProps}/>
            <TimeSelector {...props.selectorProps}/>
        </div>
    )
}